<template>
  <div class="ideas__filters">
    <div class="sticky-wrapper">
      <!-- TODO: move the search comp to components/library -->
      <div
        v-if="ff_search || $mq === 'sm' || $mq === 'md'"
        class="filter-search"
      >
        <Search
          v-if="ff_search"
          :value="this.$store.state.ideas.filters.ticker_contains || ''"
          @search="
            searchString = $event
            debouncedSearch()
          "
        />
        <div
          @click="
            mobileFiltersIsOpened = true
            $emit('openFilters', true)
          "
          class="icon-wrapper d-md-none"
        >
          <icon-filter />
        </div>
      </div>
      <div
        v-if="mobileFiltersIsOpened || ($mq !== 'sm' && $mq !== 'md')"
        class="mobile-hidden"
      >
        <div class="title d-md-none">
          <h4 class="mb-1">{{ $t('ideas.filters.mobile.title') }}</h4>
          <icon-close
            @click.native="closeMobileFilters()"
            :size="14"
            class="close"
          />
        </div>
        <filters-item
          v-for="(filter, index) of filters"
          @activateFilter="pushFilterToRouter($event, filter)"
          :key="index"
          :filter="filter"
          :activatedFilter="$store.state.ideas.filters[filter.queryParam]"
        />
        <transition name="fade">
          <button
            v-if="Object.keys($store.state.ideas.filters).length"
            @click="clearFilters()"
            class="clear"
          >
            {{ $t('ideas.filters.filter.remove') }}
          </button>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Calendar/CalendarSoritng/Search'
import FiltersItem from './FiltersItem'
import iclose from '@/components/icons/close'
import ifilter from '@/components/icons/filter'

import { debounce } from 'lodash'

export default {
  data() {
    return {
      // feature flag search
      ff_search: true,
      mobileFiltersIsOpened: false,
      searchString: '',
    }
  },
  created() {
    if (this.$route.query) {
      this.$store.dispatch('ideas/activateFilters', this.$route.query)
      this.searchString = this.$store.state.ideas.filters.ticker_contains || ''
    }
  },
  methods: {
    searchFilter(value) {
      // TODO: add ticker_contains to the pushFilter action in store
      if (this.$store.state.ideas.filters.ticker_contains !== value.trim()) {
        this.$store.commit('ideas/pushFilter', {
          param: { queryParam: value.trim() },
          filter: { queryParam: 'ticker_contains' },
        })
        this.$router.push({
          query: this.$store.state.ideas.filters,
        })
      }
    },
    pushFilterToRouter(param, filter) {
      this.$store.commit('ideas/pushFilter', { param, filter })
      this.$router.push({
        query: this.$store.state.ideas.filters,
      })
      this.closeMobileFilters()
    },
    loadDataWithFilters() {
      window.scrollTo(0, 0)
      this.$store.commit('ideas/setPages', 0)
      this.$store.dispatch('ideas/loadIdeasList')
    },
    clearFilters() {
      this.$router.push({
        query: {},
      })
      this.closeMobileFilters()
    },
    closeMobileFilters() {
      if (this.$mq === 'sm' || this.$mq === 'md') {
        this.mobileFiltersIsOpened = false
        this.$emit('openFilters', false)
      }
    },
  },
  computed: {
    debouncedSearch() {
      return debounce(() => {
        this.searchFilter(this.searchString)
      }, 300)
    },
    filters() {
      return this.$store.getters['ideas/getFilters']
    },
  },
  watch: {
    $route() {
      this.$store.dispatch('ideas/activateFilters', this.$route.query)
      this.loadDataWithFilters()
    },
  },
  components: {
    Search,
    FiltersItem,
    'icon-close': iclose,
    'icon-filter': ifilter,
  },
}
</script>

<style lang="scss">
.ideas__filters {
  flex: 1 1 260px;
  padding: 2px 0px 0px 2px;
  & .sticky-wrapper,
  & .mobile-hidden {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .title {
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 6px;
    }
    .clear {
      padding: 0 24px;
      border: 1px solid $primary-color2;
      border-radius: 4px;
      background: inherit;
      font-size: 12px;
      line-height: 30px;
      text-align: center;
      color: $primary-color2;
      width: fit-content;
      transition: all 0.3s ease-in-out;
      &:hover {
        background: $primary-color2;
        color: #ffffff;
      }
      &.fade-leave-active {
        transition: opacity 0.3s ease-in-out;
      }
      &.fade-leave-to {
        opacity: 0;
      }
    }
  }
  .sticky-wrapper {
    position: sticky;
    top: 30px;
    .filter-search {
      display: flex;
      .icon-wrapper {
        width: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #eaeaf5;
        border-radius: 4px;
        box-sizing: border-box;
      }
    }
  }

  @media (max-width: 767px) {
    flex: 0 0 auto;
    margin-bottom: 16px;

    .mobile-hidden {
      position: fixed;
      background: white;
      z-index: 10;
      top: 0;
      left: 0;
      padding: 80px 64px;
      width: 100%;
      height: 100vh;
      overflow-y: scroll;
    }
    .sticky-wrapper {
      .filter-search {
        .icon-wrapper {
          height: 34px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .mobile-hidden {
      padding: 58px 16px;
    }
    .sticky-wrapper {
      .filter-search {
        .icon-wrapper {
          height: 28px;
        }
      }
    }
  }
}

#app[data-theme='dark'] {
  .ideas__filters {
    & .mobile-hidden {
      background: black;
    }
  }
}
</style>
